import React, { useEffect, useState } from 'react'
import { Transition } from 'react-transition-group'
import { GridItem } from '@zuto/core/src/grid'

const duration = 300

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0.5
}

const transitionStyles: Record<string, { opacity: number }> = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 }
}

const withFade = <PropsType extends object>(
  WrappedComponent: React.ComponentType<PropsType>
) => (props: PropsType): JSX.Element => {
    const [isMounted, setIsMounted] = useState(false)

    useEffect(() => {
      setTimeout(() => {
        setIsMounted(true)
      }, 100)
    }, [isMounted])

    return (
      <Transition timeout={500} in={isMounted}>
        { (state) => (
          <GridItem gridColumn={['auto / span 12', '3 / span 8']}>
            <div style={{
              ...defaultStyle,
              ...transitionStyles[state]
            }}
            >
              <WrappedComponent {...props} />
            </div>
          </GridItem>
        ) }
      </Transition>
    )
  }

export default withFade
